/*
 * UserSection.tsx
 * Author: fwunderlich
 * Date: 08.02.2024
 *
 * Copyright: DMT GmbH & Co. KG
 */

import '../style/Stammdaten.scss';

import React, {useEffect, useState} from 'react';

import {useTranslation} from 'react-i18next';
import {checkPermission} from '../functions/functionLibrary';
import {permissions} from '../config/permissions';
import ViewButtons from '../components/global/ViewButtons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
    faListCheck
} from '@fortawesome/free-solid-svg-icons';
import LayoutMainContentTabMenu from '../components/global/LayoutMainContentTabMenu';
import UnderConstruction from './pages/UnderConstruction';

type Props = {
    project: any
}

const UserSection = (props: Props): JSX.Element => {

    const {t} = useTranslation(['common']);

    const projectId = props.project ? props.project.id : '';

    const [isAdmin, setIsAdmin] = useState<boolean>(false);
    const [menuItems, setMenuItems] = useState<any[]>([]);
    const [viewButtonsRerender, setViewButtonsRerender] = useState<boolean>(true);

    const userString = localStorage.getItem('user');
    let user: any = {};

    if (userString) {
        user = JSON.parse(userString)[0];
    }

    useEffect(() => {
        if (checkPermission(permissions.isAdmin)) {
            setIsAdmin(true);
        }
        console.log(user);
    }, []);

    useEffect(() => {

        const items: any[] = [];

        setMenuItems([
            {
                id: 'Task',
                label: t('task:plural'),
                icon: <FontAwesomeIcon className="sidebar-icon mr-2" icon={faListCheck}/>,
                component: <UnderConstruction/>,
                buttons: <ViewButtons title={t('')} items={items} rerender={viewButtonsRerender}/>
            },
        ]);
    }, []);

    return (
        <div className={'card'}>
            <UnderConstruction/>
            {/*<LayoutMainContentTabMenu*/}
            {/*    items={menuItems}*/}
            {/*    activeIndex={0}*/}
            {/*    onTabChange={() => {*/}
            {/*        setViewButtonsRerender(!viewButtonsRerender);*/}
            {/*    }}*/}
            {/*/>*/}
        </div>
    );
};

export default UserSection;
